import { render } from "./CustomizeCookiesCheckbox.vue?vue&type=template&id=4ff017de"
import script from "./CustomizeCookiesCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomizeCookiesCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__